import { createRouter, createWebHistory } from "vue-router";
import Hem from "@/views/Startsida.vue";
import Svara from "@/views/Svara.vue";
import { useStore } from "@/store";
import i18n from "../i18n";

const kontrolleraVerifierad = (): { name: string } | boolean => {
	const store = useStore();
	if (!store.state.verifierad) {
		return { name: "Hem" };
	}
	return true;
};

const router = createRouter({
	history: createWebHistory(),
	routes: [
		{
			path: "/",
			name: "Hem",
			component: Hem,
			meta: {
				title: i18n.global.t("main.page_title_start")
			},
		},
		
		{
			path: "/svara",
			name: "Svara",
			component: Svara,
			meta: {
				title: i18n.global.t("main.page_title_submit")
			},
			// Navigation guard
			beforeEnter: kontrolleraVerifierad
		},

		{
			path:"/kvittens",
			name: "Kvittens",
			component: Svara,
			meta: {
				title: i18n.global.t("main.page_title_receipt")
			},
			// Navigation guard
			beforeEnter: kontrolleraVerifierad
		},
		
		{	
			path: '/:pathMatch(.*)*', 
			redirect: { name: "Hem", params: {} }
		},
	]
});

router.beforeEach((to, from, next) => {
	const nyTitel = to.meta.title as string;
	if(nyTitel) {
		const gammalTitel: string = document.title;
		const idx: number = gammalTitel.indexOf("]");
		if (idx != -1) {
			document.title = `${gammalTitel.substring(0, idx+1)} ${nyTitel}`;
		} else {
			document.title = nyTitel;
		}
	}
	next();
});

export default router;
